/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_2Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_3_steps_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save from GridCraft, reopen in Excel and review the result. Ask a collaborator to inspect the file if sharing is part of the real task. A successful save is only the middle of the test.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_3_steps_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从 GridCraft 保存后，再用 Excel 打开并检查结果。如果实际任务涉及分享，也应请协作者检查文件。保存成功只是测试的中间步骤。`)
};

/**
* | output |
* | --- |
* | "Save from GridCraft, reopen in Excel and review the result. Ask a collaborator to inspect the file if sharing is part of the real task. A successful save is ..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_3_steps_2 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_3_steps_2(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_3_steps_2(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_3_steps_2 as "gc.search_guides.gridcraft_vs_excel.sections.3.steps.2" }